import React from 'react';
import { ChevronRight } from 'lucide-react';

/**
 * Reusable header component for all Demand Management pages
 * Provides consistent breadcrumbs, title, and description
 */
const DemandPageHeader = ({ 
  title, 
  description, 
  breadcrumbPath = "Demand Management",
  children 
}) => {
  return (
    <div style={{ marginBottom: '32px' }}>
      {/* Breadcrumb */}
      <div style={{
        fontSize: '14px',
        color: 'var(--cares-text-label)',
        marginBottom: '12px',
        paddingTop: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <span style={{ color: 'var(--cares-text-note)' }}>Home</span>
        <ChevronRight size={14} style={{ color: 'var(--cares-text-note)' }} />
        <span style={{ color: 'var(--cares-text-note)' }}>Demand Management</span>
        {breadcrumbPath !== "Demand Management" && (
          <>
            <ChevronRight size={14} style={{ color: 'var(--cares-text-note)' }} />
            <span style={{ color: 'var(--cares-text-3)', fontWeight: '500' }}>{breadcrumbPath}</span>
          </>
        )}
      </div>

      {/* Title and Description */}
      <div style={{
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px'
      }}>
        <div style={{ flex: 1 }}>
          <h1 style={{
            fontSize: '28px',
            fontWeight: 'bold',
            color: 'var(--cares-text-2)',
            marginBottom: '8px',
            lineHeight: '1.2'
          }}>
            {title}
          </h1>
          {description && (
            <p style={{
              color: 'var(--cares-text-label)',
              fontSize: '14px',
              lineHeight: '1.5'
            }}>
              {description}
            </p>
          )}
        </div>
        {children && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '12px'
          }}>
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default DemandPageHeader;

